import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { logout } from "../app/slice/authSlice";
import { getAuthProps } from "../utils/authentication/authLibrary";
import { generalMenuItems, adminMenuItems } from "./sidebar.config";

import { filterMenu } from "../utils/common/sidebarHelper";
import PropTypes from 'prop-types';
import "./Sidebar.scss";
import { useMenu } from "../context/MenuContext";

const Sidebar = ({ isClosed, openMenus, toggleMenu }) => {

  const dispatch = useDispatch();

  const authData = getAuthProps();
  let userInfo = authData?.user;

  const userFullName = [userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(" ") || "User";

  const { showAdminMenu } = useMenu();

  const menuToUse = showAdminMenu ? adminMenuItems : generalMenuItems;

  const sidebarMenuToLoad = useMemo(() => filterMenu(menuToUse), [menuToUse]);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="sidebar-menu-list">
      <div className={`sidebar ${isClosed ? "close" : ""}`}>
        <div className="logo-details">
          <span className="logos">
            <img
              className="big-logo"
              src="/images/logoW.png"
              alt="profileImg"
            />
            <img
              className="small-logo"
              src="/images/icon.png"
              alt="profileImg"
            />
          </span>
        </div>

        <ul className="nav-links">
          {sidebarMenuToLoad.map((section) => (
            <React.Fragment key={section.id || section.section}>
              {/* Section Title */}
              <li className="menu-title">{section.section}</li>

              {/* Section Items */}
              {section.items.map((item) =>
                item.profile ? (
                  <li key={item.id}>
                    <div className="profile-details">
                      <div className="profile-content">
                        <img src={item.image} alt="profileImg" />
                      </div>
                      <div className="name-job">
                        <div className="profile_name">{item.name}</div>
                        <div className="job">{item.job}</div>
                      </div>
                      <i className={item.icon}></i>
                    </div>
                  </li>
                ) : (
                  <li
                    key={item.id}
                    className={
                      item.subMenu &&
                        !item.subMenu[0]?.blank &&
                        openMenus[item.id]
                        ? "showMenu"
                        : ""
                    }
                  >
                    <div
                      className={item.subMenu && !item.subMenu[0]?.blank ? "iocn-link" : ""}
                      role="button"
                      tabIndex={0}
                      onClick={() => toggleMenu(item.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleMenu(item.id);
                        }
                      }}
                    >
                      <Link to={item.path}>
                        <i className={item.icon}></i>
                        <span className="link_name">{item.title}</span>
                      </Link>
                      {item.subMenu && !item.subMenu[0]?.blank && (
                        <i className="pi pi-chevron-down arrow-icon"></i>
                      )}
                    </div>
                    {item.subMenu && (
                      <ul
                        className={`sub-menu ${item.subMenu[0]?.blank ? "blank" : ""
                          }`}
                      >
                        {item.subMenu.map((sub) => (
                          <li key={sub.id || sub.path}>
                            <Link
                              to={sub.path}
                              className={
                                sub.title === item.title ? "link_name" : ""
                              }
                            >
                              {sub.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )
              )}
            </React.Fragment>
          ))}
        </ul>
        {/* User at bottom */}
        <span className="user-name">
          <div className="user">
            <i className="pi pi pi-user"></i>
            <h5>{userFullName}</h5>
          </div>
          <i
            className="pi pi-sign-out logout"
            role="button"
            tabIndex={0}
            onClick={handleLogout}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleLogout(); }}
            aria-label="Logout"
          />
        </span>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  isClosed: PropTypes.bool,
  openMenus: PropTypes.objectOf(PropTypes.bool),
  toggleMenu: PropTypes.func.isRequired,
};

export default Sidebar;
